import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OnboardingSessionService } from '../../../modules/onboarding/services/onboarding-session.service';
import {
  canAccessOnboardingRoute,
  ONBOARDING_STEP_ROUTES,
  resolveOnboardingRoute,
} from '../../utils/onboarding-session.util';

/**
 * Requires an onboarding session token (independent from portal login).
 */
export const onboardingGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const onboardingSession = inject(OnboardingSessionService);
  const token = onboardingSession.getAccessToken();

  if (!token) {
    router.navigate(['/auth/register'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }

  const storedStep = onboardingSession.getStep();
  if (!storedStep) {
    return true;
  }

  if (canAccessOnboardingRoute(storedStep, state.url)) {
    return true;
  }

  const fallbackRoute =
    ONBOARDING_STEP_ROUTES[storedStep] ?? resolveOnboardingRoute(storedStep);
  router.navigateByUrl(fallbackRoute);
  return false;
};
